jQuery( document ).ready(function($) {
    jQuery('.iwadstep2').hide();
    
    jQuery('#iwadresult').submit(function(e) {
        e.preventDefault();
        
        /*get age in years*/
        $birthday = jQuery('#date').val().split('/');
        $birthdayvar = ($birthday[2] + '-' + $birthday[1] + '-' + $birthday[0]).replace(/\s/g,'');
        $todaydate = new Date();
        $birthdate = new Date($birthdayvar);
        $age =  Math.floor(($todaydate - $birthdate) / (365.25 * 24 * 60 * 60 * 1000));
        $yearslefttowork = 0;
    /*
        //work out hours worked based on a starting work age of 18 from date of birth
        $byear = $birthdate.getFullYear();
        $bmonth = $birthdate.getMonth();
        $bday = $birthdate.getDate();
        $startwork = new Date($byear + 18, $bmonth, $bday)
        $hoursworked = Math.round(Math.abs($todaydate - $startwork) / 36e5);

        //age left to work based on retirement age for male and 64 for female
        $gender = jQuery("input:radio[name ='gender']:checked").val();
        if($gender == "female") {
            $yearslefttowork = 64 - $age;
        } else if($gender == "male") {
            $yearslefttowork = 65 - $age;
        } else {
            $yearslefttowork = 64 - $age;
        }

        //how many hours tea breaks based on 110 hours per year as the average
        $hoursteabreak = ($age - 18)*110;

        //hours commuting based on 67 minutes a day
        $daysworked = Math.round(Math.abs($todaydate - $startwork)/(1000*60*60*24));
        $hourscommuting = Math.round($daysworked * (67/60));
        
        //holiday taken based on 33 days per year
        $yearsworked = Math.abs($todaydate - $startwork) / (365.25 * 24 * 60 * 60 * 1000);
        $daysleavetaken = Math.round($yearsworked * 33);
    */

        //age left to work based on retirement age for male and 64 for female
        $gender = jQuery("input:radio[name ='gender']:checked").val();
        if($gender == "female") {
            $yearslefttowork = 64 - $age;
            $daysleavetaken = '1,518';
            $hourscommuting = '13,313';
            $hoursteabreak = '5,044';
        } else if($gender == "male") {
            $yearslefttowork = 65 - $age;
            $daysleavetaken = '1,551';
            $hourscommuting = '13,602';
            $hoursteabreak = '5,154';
        } else {
            $yearslefttowork = 65 - $age;
            $daysleavetaken = '1,551';
            $hourscommuting = '13,602';
            $hoursteabreak = '5,154';
        }

        jQuery('#iwadstepone').fadeOut(300);
        jQuery('#iwadsteptwo').fadeIn(300);

        jQuery('.yearsleftp .numbervalue').text($yearslefttowork);
        jQuery('.yearsleftp .textvalue').text('years');

        jQuery('.holidaystakenp .numbervalue').text($daysleavetaken);
        jQuery('.holidaystakenp .textvalue').text('days');

        jQuery('.hourscommutedp .numbervalue').text($hourscommuting);
        jQuery('.hourscommutedp .textvalue').text('hours');

        jQuery('.teabreaksp .numbervalue').text($hoursteabreak);
        jQuery('.teabreaksp .textvalue').text('hours');



        jQuery('.yearslefta .numbervalue').text('X');
        jQuery('.yearslefta .textvalue').text('');

        jQuery('.holidaystakena .numbervalue').text('0');
        jQuery('.holidaystakena .textvalue').text('days');

        jQuery('.hourscommuteda .numbervalue').text('35,040');
        jQuery('.hourscommuteda .textvalue').text('hours');

        jQuery('.teabreaksa .numbervalue').text('0');
        jQuery('.teabreaksa .textvalue').text('hours');

    });

});
